import {
  logoutAction,
  PatientloginAction,
} from './actions/LoginActions';
import {
  Field,
  reduxForm,
} from 'redux-form';
import GlobalVariables from '../../../actions/utilAction';
import {
  isValidName,  
  renderTextField,
  renderPasswordField,
} from '../../../components/reduxFields';
import {
  LoginButton,
  LoginButtonDisabled,
} from '../../../components/buttons';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import validate from './validate';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  onSubmit(authData) {
    authData.password = authData.password;
    if (authData.password) {
      authData.ipaddress = GlobalVariables.IpAddress;
      authData.macaddress = 'ec:aa:a0:2d:dc:67';
      this.props.PatientloginAction(authData, this.props.businessNameCheck);
    }
  }

  renderLoginForm() {
    const { handleSubmit, businessNameCheck, errorMessage, successMessage, loginHeaderComponent } = this.props;
    if (businessNameCheck) {
      return (
        <div className="login-fields">
          {loginHeaderComponent}
          <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            {(errorMessage && <div className="alert-danger">{errorMessage}</div>)
              ||
            (successMessage && <div className="alert-success">{successMessage}</div>)}
            <Field
              name="userName"
              type="text"
              maxLength="60"
              normalize={isValidName}
              label="User Name"
              component={renderTextField} />
            <Field         
              name="password"
              maxLength="30"
              label="Password"
              type="password"             
              component={renderPasswordField}
            />
            <div className="mt-15">
              {/* <Field
                name="rememberme"
                label="Remember Me"
                className="rem custm_check"
                component={renderCheckBox} /> */}
              <div className="frgtpwd">
                <NavLink exact to="/forgot-password">Forgot Password?</NavLink>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="mt-30">
              {this.props.authenticating ? <LoginButtonDisabled label="Logging In..." /> : <LoginButton label="Log In" />}
            </div>
            <div className="loginas">
              <span>OR</span>
              <p>login as <NavLink exact to="/login">Agency</NavLink></p>
            </div>
          </form>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.renderLoginForm()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticating: state.login.authenticating,
    businessNameCheck: state.login.businessNameCheck,
  };
}

Login = reduxForm({
  form: 'loginForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(Login);

export default connect(mapStateToProps, {
  PatientloginAction,
  logoutAction,
})(Login);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/logins/login.js